'use strict';

import config from '../config/config';
import {throttle} from '../components/custom-lodash';

const mobileMQ = window.matchMedia(`(max-width: ${config.BREAKPOINTS.TABLET_MAX}px)`);

let listingOptions = null;

const stickyListingOptions = () => {
    const breadcrumb = document.querySelector('.breadcrumb');
    const logo = document.querySelector('.header-mobile-main');
    const stickyHeight = breadcrumb.offsetTop + breadcrumb.clientHeight + logo.clientHeight;

    //sticky the element a little bit after scrolling to it
    if (window.pageYOffset > stickyHeight) {
        listingOptions.classList.add('is-sticky');
    } else {
        listingOptions.classList.remove('is-sticky');
    }
};

/**
 * Event handler as a named function so it can be removed from the scroll events on resize
 */
const stickyEventHandler = throttle(function () {
    stickyListingOptions();
}, 100);

const startSticky = () => {
    listingOptions = document.querySelector('.listing-options');
    stickyListingOptions();
    window.addEventListener('scroll', stickyEventHandler);
};

export const init = () => {
    listingOptions = document.querySelector('.listing-options');
    const nonStickySortAndFilter = document.querySelector('.non-sticky-sort-and-filter');

    if (!listingOptions || nonStickySortAndFilter !== null) {
        return;
    }

    if (mobileMQ.matches) {
        startSticky();
    }

    window.addEventListener(
        'resize',
        throttle(() => {
            if (mobileMQ.matches) {
                startSticky();
            } else {
                window.removeEventListener('scroll', stickyEventHandler);
                listingOptions.classList.remove('is-sticky');
            }
        }, 100)
    );

    document.body.addEventListener('plp.updateproductlisting.done', startSticky);
};
